export const transition1 = {
    duration: 1.1,
    ease: [0.6, 0.01, 0.05, 0.9],

    // ease: [0.43, 0.13, 0.23, 0.96],
}